import React, { FC } from 'react';
import MachinesProvider from '@v2/pages/machines/common/providers/MachinesProvider/MachinesProvider';
import { TimelineItemsList } from '@v2/pages/machines/modules/timeline/components/TimelineItemsList/TimelineItemsList';
import { NavigationProps } from '@interfaces/navigation';
import BatchTimeLine from '@v2/pages/batch/details/modules/batch/components/BatchTimeline/BatchTimeline';

interface BatchTimelineScreenProps extends NavigationProps {}

const BatchTimelineScreen: FC<BatchTimelineScreenProps> = ({ lg }) => {
  return (
    <MachinesProvider withDefaultComponent lg={lg} panelViewMode={false} onBack={() => {}} getList={(props) => <TimelineItemsList {...props} />}>
      <BatchTimeLine shouldSetEndTimeAsNow />
    </MachinesProvider>
  );
};

export { BatchTimelineScreen };
